export const PROCESS_MESSAGES={
    PROCESS_ABORTED: "Process \"{0}\" aborted by user.",
    PROCESS_NOT_ABORTED: "Error in aborting the process.",
    PROCESS_STARTED: "Process \"{0}\" started.",
    PROCESS_NOT_STARTED: "Process \"{0}\" not started.",
}

/*************************************BACKUP**************************************************************************/
export const BACKUP_MESSAGES={

    CREATED: "Backup \"{0}\" created successfully.",
    NOT_CREATED: "An error occurred while creating the backup \"{0}\".",
    SAVED: "Backup \"{0}\" saved successfully.",
    NOT_SAVED: "An error occurred while saving the backup \"{0}\".",
    SAVE_LATER: "\"{0}\" is offline. The backup will be saved when you are online again.",
    MODIFIED: "Backup \"{0}\" modified successfully.",
    NOT_MODIFIED: "An error occurred while editing the backup \"{0}\".",
    DELETED: "Backup \"{0}\" deleted successfully.",
    NOT_DELETED: "An error occurred while deleting the backup \"{0}\".",
    LIST_NOT_RETRIEVED: "An error occurred while retrieving the backups.",
    NOTIFICATIONS_NOT_RETRIEVED: "An error occurred while retrieving the notifications jobs.",
    NOT_RETRIEVED: "An error occurred while retrieving the backup \"{0}\".",

    LOGS_NOT_RETRIEVED: "An error occurred while retrieving logs of backup.",

    COMPLETED: "Backup \"{0}\" completed successfully.",
    NOT_COMPLETED: "Backup \"{0}\" completed with errors.",
    WARNINGS: "Backup \"{0}\" completed with warnings.",
    ERROR: "There were errors in running the selected backup job: {0}",

    ABORTED: "Backup Job \"{0}\" aborted by user.",
    NOT_ABORTED: "Error in aborting the job \"{0}\".",
    ABORTING: "Aborting job \"{0}\"",

    NOT_FOUND: "Backup Job \"{0}\" not found.",

    RENAMED: "Backup Job \"{0}\" renamed successfully in \"{1}\"",
    NOT_RENAMED: "Error in renaming the job \"{0}\" in \"{1}\".",

    RUNNING: "Running job \"{0}\"",
    NOT_RUNNING: "There were errors in running the job \"{0}\"",

    CHOOSE_SOURCE: "Configure a source!",
    CHOOSE_DESTINATION: "Configure a destination!",

    LOG_DETAIL_NOT_RETRIEVED: "An error occurred while retrieving the log details \"{0}\"",

    ADD_TO_NOTIFICATIONS: "Device added to the notifications",
    REMOVE_FROM_NOTIFICATIONS: "Device removed from the notifications",
}

/*************************************SERVICE ACCOUNTS**************************************************************************/

export const SERVICEACCOUNT_MESSAGES={
    CREATED: "Service account \"{0}\" created successfully.",
    NOT_CREATED: "An error occurred while creating the service account \"{0}\".",
    MODIFIED: "Service account \"{0}\" modified successfully.",
    NOT_MODIFIED: "An error occurred while editing the service account \"{0}\".",
    DELETED: "Service account \"{0}\" deleted successfully.",
    NOT_DELETED: "An error occurred while deleting the service account \"{0}\".",
    LIST_NOT_RETRIEVED: "An error occurred while retrieving the service accounts.",
    NOT_RETRIEVED: "An error occurred while retrieving the service account.",
    TEST_FAILED: "An error occurred while testing the service account \"{0}\".",
    TEST_OK: "Service account \"{0}\" tested successfully",
    SAVE_LATER: "\"{0}\" is offline. The service account will be saved when you are online again.",
}


export const SESSIONS_MESSAGES={
    CREATED: "Session \"{0}\" created successfully.",
    NOT_CREATED: "An error occurred while creating the session \"{0}\".",
    MODIFIED: "Session \"{0}\" modified successfully.",
    NOT_MODIFIED: "An error occurred while editing the session \"{0}\".",
    DELETED: "Session \"{0}\" deleted successfully.",
    NOT_DELETED: "An error occurred while deleting the session \"{0}\".",
    LIST_NOT_RETRIEVED: "An error occurred while retrieving the sessions.",
    NOT_RETRIEVED: "An error occurred while retrieving the session.",
    SAVE_LATER: "\"{0}\" is offline. The session will be saved when you are online again.",

}

/*************************************REPOSITORY**************************************************************************/

export const REPOSITORY_MESSAGES={
    CREATED: "Repository \"{0}\" created successfully.",
    NOT_CREATED: "An error occurred while creating the repository \"{0}\".",
    MODIFIED: "Repository \"{0}\" modified successfully.",
    NOT_MODIFIED: "An error occurred while editing the repository \"{0}\".",
    DELETED: "Repository \"{0}\" deleted successfully.",
    NOT_DELETED: "An error occurred while deleting the repository \"{0}\".",
    LIST_NOT_RETRIEVED: "An error occurred while retrieving the repositories.",
    NOT_RETRIEVED: "An error occurred while retrieving the repository.",
    SAVE_LATER: "\"{0}\" is offline. The repository will be saved when you are online again.",
}


/*************************************PC**************************************************************************/
export const PC_MESSAGES={
    LIST_NOT_RETRIEVED: "An error occurred while retrieving the computers.",
    NOT_RETRIEVED: "An error occurred while retrieving the computer.",
    CONNECTED: "Computer \"{0}\" connected.",
    NOT_CONNECTED: "Computer \"{0}\" is not connected.",
    NO_RESPONSE: "No response from server.",
    ERROR: "Generic Error, please retry",
    SAVED: "Computer modified successfully",
    PASSWORD_ERROR: "Password Custom non saved.",
    PASSWORD_OK: "Password Custom saved successfully.",
    PASSWORD_REMOVED: "Password Custom removed successfully.",
    LICENSE_REMOVED: "Device removed from license successfully.",
    NOTE_NOT_SAVED: "Note not saved.",
    NOTE_SAVED: "Note saved successfully.",
    LICENSE_ADDED: "Device linked to license successfully. Reconnect manually using howto.",
    REMOVE_FROM_MODULE: "Device removed from the license module",
    REMOVE_FROM_MODULE_ERR: "Unable to remove the device from the license module",
    ADD_TO_MODULE: "Device added to the license module",
    ADD_TO_MODULE_ERR: "Unable to add the device to the license module",
    ADD_TO_FAVORITES: "Device added to the favorites",
    REMOVE_FROM_FAVORITES: "Device removed from the favorites",
    LATEST_VERSION_NOT_RETRIEVED: "Failed to retrieve the latest update version.",
    REMOVE_FROM_ADDRESSBOOK: "Computer removed from the address book.",
    REMOVE_FROM_ADDRESSBOOK_ERR: "Unable to remove the computer from the address book."
}

/*************************************TFA**************************************************************************/
export const TFA_MESSAGES={
    ENABLED: "TFA enabled successfully",
    DISABLED: "TFA disabled successfully",
    NOT_DISABLED: "An error occurred while disabling TFA.",
    NOT_ENABLED: "An error occurred while enabling the TFA."
}

/*************************************TFA**************************************************************************/
export const EVENTS_MESSAGES={
    EVENTS_READED: "Event read successfully",
    EVENTS_NOT_RETRIEVED: "An error occurred while retrieving events.",
    EVENTS_RETRIEVED: "Events retrieved successfully",
}


/*************************************USER**************************************************************************/

export const USER_MESSAGES={
    CREATED: "User created successfully.",
    NOT_CREATED: "An error occurred while creating the user.",
    MODIFIED: "User modified successfully.",
    NOT_MODIFIED: "An error occurred while editing the user.",
    DELETED: "User deleted successfully.",
    NOT_DELETED: "An error occurred while deleting the user.",
    LIST_NOT_RETRIEVED: "An error occurred while retrieving the users.",
    NOT_RETRIEVED: "An error occurred while retrieving the user.",
    CONNECTED: "You are online",
    NOT_CONNECTED: "You are offline.",
    SENT: "Reset Password email sent successfully.",
    NOT_SENT: "An error occurred while sending the Reset Password email.",
    PASSWORD_RESET_FAILED: "An error occurred while resetting the password.",
}

/*************************************GROUP**************************************************************************/

export const GROUP_MESSAGES={
    CREATED: "Group created successfully.",
    NOT_CREATED: "An error occurred while creating the Group.",
    MODIFIED: "Group modified successfully.",
    NOT_MODIFIED: "An error occurred while editing the Group.",
    DELETED: "Group deleted successfully.",
    NOT_DELETED: "An error occurred while deleting the Group.",
    LIST_NOT_RETRIEVED: "An error occurred while retrieving groups.",
    NOT_RETRIEVED: "An error occurred while retrieving the Group.",
    CONNECTED: "You are online",
    NOT_CONNECTED: "You are offline."
}

/*************************************POLICY**************************************************************************/
export const POLICY_MESSAGES={
    CREATED: "Policy created successfully.",
    NOT_CREATED: "An error occurred while creating the Policy.",
    MODIFIED: "Policy modified successfully.",
    NOT_MODIFIED: "An error occurred while editing the Policy.",
    DELETED: "Policy deleted successfully.",
    NOT_DELETED: "An error occurred while deleting the Policy.",
    LIST_NOT_RETRIEVED: "An error occurred while retrieving the Policy.",
    NOT_RETRIEVED: "An error occurred while retrieving the Policy."
}

export const CLOUD_MESSAGES={
    AUTH_IN_PROGRESS : "Authentication in progress",
    AUTH_OK : "Authentication successful",
    AUTH_NOT_OK : "An error occurred during authentication",
    
    LIST_BUCKETS: "Trying to retrieve buckets",
    LIST_BUCKETS_OK: "Buckets retrieved successfully",
    LIST_BUCKETS_NOT_OK: "An error occurred while retrieving the buckets.",

    LIST_CONTAINERS: "Trying to retrieve containers",
    LIST_CONTAINERS_OK: "Containers retrieved successfully",
    LIST_CONTAINERS_NOT_OK: "An error occurred while retrieving the containers.",

    LIST_SHARES: "Trying to retrieve shares",
    LIST_SHARES_OK: "Shares retrieved successfully",
    LIST_SHARES_NOT_OK: "An error occurred while retrieving the shares.",

    LIST_RESOURCES: "Trying to retrieve resources from path '{0}'",
    LIST_RESOURCES_OK: "Resources retrieved successfully",
    LIST_RESOURCES_NOT_OK: "An error occurred while retrieving resources from {0}"
}

/*************************************LOGIN**************************************************************************/

export const LOGIN_FAILED="An error occurred while logging in.";
export const LOGOUT_FAILED="An error occurred while logging out.";

export const TOKENS_NOT_RETRIEVED="An error occurred while retrieving the tokens.";
export const STEP_ACQUIRE_TOKENS="I acquire the new tokens.";

/*************************************LIST**************************************************************************/

export const REGIONS_NOT_RETRIEVED="An error occurred while retrieving the regions.";
export const POLICY_NOT_RETRIEVED="An error occurred while retrieving policy.";
export const POLICIES_NOT_RETRIEVED="An error occurred while retrieving polices.";
export const CONTROLS_NOT_RETRIEVED="An error occurred while retrieving computers connected.";
export const GROUPS_NOT_RETRIEVED="An error occurred while retrieving groups.";
export const ROLES_NOT_RETRIEVED="An error occurred while retrieving roles.";
export const PRICING_NOT_RETRIEVED="An error occurred while retrieving pricing.";
export const LICENSES_NOT_RETRIEVED="An error occurred while retrieving licenses.";
export const COMPANY_NOT_UPDATED="An error occurred while updating the company.";
export const EMAILPROVIDERS_NOT_RETRIEVED="An error occurred while retrieving email providers.";
export const EVENTLOGS_NOT_RETRIEVED="An error occurred while retrieving eventlogs.";
export const TYPES_NOT_RETRIEVED="An error occurred while retrieving event types.";

/*************************************MISCELLANEOUS**************************************************************************/

export const ERROR="An error occurred."
export const STATS_NOT_RETRIEVED="An error occurred while retrieving statistics.";
export const NO_UPPERCASE_CHARACTERS="No uppercase characters in password.";
export const FILESYSTEM_NOT_RETRIEVED="An error occurred while retrieving filesystem.";
export const EXTENSION_NOT_VALID="Extension not valid."

export const FOLDER_CREATED="Folder {0} created";
export const FOLDER_NOT_CREATED="An error occurred while creating the folder {0} ";

export const ITEM_DELETED="Item deleted";
export const ITEM_NOT_DELETED="An error occurred while deleting the selected item";
export const ITEMINFO_NOT_RETRIEVED="An error occurred while retrieving the selected item info";
export const ITEMS_NOT_RETRIEVED="An error occurred while retrieving items";
export const ITEM_RENAMED="Item renamed";
export const ITEM_NOT_RENAMED="An error occurred while renaming the selected item";

//[TG 18/06/2024 - messaggio per criptazione stringhe su api]
export const COCOD_ERROR_CRYPT="An error occurred while retrieving the agent build page URL (control code not valid).";
export const STRING_ERROR_CRYPT="An error occurred while retrieving the agent build page URL (param non valid).";
export const LIC_EXT_INFO_ERR="An error occurred while retrieving the info about current license.";

export const GET_REMOTE_STATS_ERR="An error occurred while retrieving the info about current remote statistics.";
export const GET_BACKUP_STATS_ERR="An error occurred while retrieving the info about current backup statistics.";

export const DATABASE_MESSAGES={
    LIST_NOT_RETRIEVED: "An error occurred while retrieving databases",
    FOUND_NEW: "New database found : \"{0}\"",
    NOT_FOUND: "The database \"{0}\" was not found"
}

export const DISK_MESSAGES={
    LIST_NOT_RETRIEVED: "An error occurred while retrieving disks",
    FOUND_NEW: "New disk found : \"{0}\"",
    NOT_FOUND: "The disk \"{0}\" was not found",
    NOT_FOUND_PARTITION: "The partition \"{0}\" of disk \"{1}\" was not found",
    FOUND_NEW_PARTITION: "New partition \"{0}\" found on disk \"{1}\"",
    NOT_RETRIEVED: "An error occurred while retrieving disk"
}

export const VIRTUAL_MACHINES_MESSAGES={
    LIST_NOT_RETRIEVED: "An error occurred while retrieving virtual machines",
    FOUND_NEW: "New virtual machine found : \"{0}\"",
    NOT_FOUND: "The virtual machine \"{0}\" was not found",
    NOT_FOUND_VIRTUAL_DISK: "The virtual disk \"{0}\" of virtual machine \"{1}\" was not found",
    FOUND_NEW_VIRTUAL_DISK: "New virtual disk \"{0}\" found on virtual machine \"{1}\"",
    STATE_CHANGED: "State of virtual machine \"{0}\" changed",
    STATE_NOT_CHANGED: "An error occurred while changing state of virtual machine \"{0}\""
}

export const DATACENTER_MESSAGES={
    LIST_NOT_RETRIEVED: "An error occurred while retrieving datacenters",
    FOUND_NEW: "New datacenter found : \"{0}\"",
    NOT_FOUND: "The datacenter \"{0}\" was not found",
    NOT_FOUND_COMPUTER: "The computer \"{0}\" of datacenter \"{1}\" was not found",
    FOUND_NEW_COMPUTER: "New computer \"{0}\" found on datacenter \"{1}\"",
    NOT_FOUND_DATASTORE: "The datastore \"{0}\" of computer \"{1}\" was not found",
    FOUND_NEW_DATASTORE: "New datastore \"{0}\" found on computer \"{1}\"",
    NOT_FOUND_VIRTUAL_MACHINE: "The virtual machine \"{0}\" of datastore \"{1}\" was not found",
    FOUND_NEW_VIRTUAL_MACHINE: "New virtual machine \"{0}\" found on datastore \"{1}\""
}

export const MAILBOXES_MESSAGES={
    LIST_NOT_RETRIEVED: "An error occurred while retrieving mailboxes",
    FOUND_NEW: "New mailbox found : \"{0}\"",
    NOT_FOUND: "The mailbox \"{0}\" was not found",
    EMAIL_SENT: "Test mail sent successfully."
}

export const RESTORE_MESSAGES={
    STARTED: "Restore process starded successfully",
    NOT_STARTED: "Restore process not starded",
    LIST_NOT_RETRIEVED: "An error occurred while retrieving the restores.",
    NOT_RETRIEVED: "An error occurred while retrieving the restore \"{0}\".",
    DELETED: "Restore \"{0}\" deleted successfully.",
    NOT_DELETED: "An error occurred while deleting the restore \"{0}\".",



}

export const NETWORK_MESSAGES={
    CONNECTED: "Network connection established",
    CONNECTION_FAILED: "An error occurred during network authentication.",
    DISCONNECT: "The disconnection was performed successfully.",
    NOT_DISCONNECT: "An error occurred while disconnecting to the network.",
    LIST_NOT_RETRIEVED: "An error occurred while retrieving filesystem."
}

export const FTP_MESSAGES={
    CONNECTED: "FTP connection established",
    CONNECTION_FAILED: "An error occurred during ftp authentication.",
    DISCONNECT: "The disconnection was performed successfully.",
    NOT_DISCONNECT: "An error occurred while disconnecting to the server.",
    LIST_NOT_RETRIEVED: "An error occurred while retrieving ftp filesystem."
}

export const RESTOREFILE_MESSAGES={
    NOT_BACKUP_FOLDER: "The selected folder does not correspond to a backup folder.",
    INFO_NOT_RETRIEVED: "An error occurred while retrieving infos about selected backup",
    RUNNING: "Running restore",
    NOT_RUNNING: "An error occurred while starting the selected restore"
}

export const IPERIUSREMOTE_MESSAGE={
    NOT_UPDATE: "An error occurred while updating Iperius Remote on the remote computer.",
    NOT_RESTART: "An error occurred while restarting Iperius Remote on the remote computer.",
    NOT_UNINSTALL: "An error occurred while disabling the unattended mode of Iperius Remote on the remote computer.",
    NOT_CLOSE: "An error occurred while terminating Iperius Remote on the remote computer.",
    NOT_VER: "An error occurred while asking the latest Iperius Remote version available.",
    NOT_STATUS: "An error occurred while checking the status of the Iperius Remote client.",
    NOT_TERMINATE: "An error occurred while terminating Iperius Remote session."
}

/*************************************REPOSITORY**************************************************************************/

export const SCRIPTS_MESSAGES={
    CREATED: "Script \"{0}\" created successfully.",
    NOT_CREATED: "An error occurred while creating the script \"{0}\".",
    MODIFIED: "Script \"{0}\" modified successfully.",
    NOT_MODIFIED: "An error occurred while editing the script \"{0}\".",
    DELETED: "Script \"{0}\" deleted successfully.",
    NOT_DELETED: "An error occurred while deleting the script \"{0}\".",
    LIST_NOT_RETRIEVED: "An error occurred while retrieving the scripts.",
    NOT_RETRIEVED: "An error occurred while retrieving the script.",
    SAVE_LATER: "\"{0}\" is offline. The script will be saved when you are online again.",
}

export const SCRIPT_DEPLOY_MESSAGES={
    CREATED: "Script deploy \"{0}\" created successfully.",
    NOT_CREATED: "An error occurred while creating the script deploy \"{0}\".",
    DELETED: "Script deploy \"{0}\" deleted successfully.",
    NOT_DELETED: "An error occurred while deleting the script deploy \"{0}\".",
    HISTORY_NOT_RETRIEVED: "An error occurred while retrieving the script deploy history.",
    RESULTS_NOT_RETRIEVED: "An error occurred while retrieving the script deploy results."
}

/*************************************TEAMS**************************************************************************/
export const TEAM_MESSAGES={
    CREATED: "Team \"{0}\" created successfully.",
    NOT_CREATED: "An error occurred while creating the team \"{0}\".",
    MODIFIED: "Team \"{0}\" modified successfully.",
    NOT_MODIFIED: "An error occurred while editing the team \"{0}\".",
    DELETED: "Team \"{0}\" deleted successfully.",
    NOT_DELETED: "An error occurred while deleting the team \"{0}\".",
    LIST_NOT_RETRIEVED: "An error occurred while retrieving the teams.",
    NOT_RETRIEVED: "An error occurred while retrieving the team.",
    MEMBER_ADDED: "Member added to the team successfully.",
    MEMBER_NOT_ADDED: "An error occurred while adding the member to the team.",
    MEMBER_REMOVED: "Member removed from the team successfully.",
    MEMBER_NOT_REMOVED: "An error occurred while removing the member from the team.",
    HOSTS_ASSIGNED: "Hosts assigned to the team successfully.",
    HOSTS_NOT_ASSIGNED: "An error occurred while assigning hosts to the team.",
    OPERATOR_TEAMS_NOT_RETRIEVED: "An error occurred while retrieving the operator's teams.",
}

/*************************************ASSISTANCE REQUESTS**************************************************************************/
export const TICKET_MESSAGES={
    CREATED: "Assistance request created successfully.",
    NOT_CREATED: "An error occurred while creating the assistance request.",
    LIST_NOT_RETRIEVED: "An error occurred while retrieving the assistance requests.",
    NOT_RETRIEVED: "An error occurred while retrieving the assistance request.",
    MODIFIED: "Ticket modified successfully.",
    NOT_MODIFIED: "An error occurred while editing the ticket.",
    DELETED: "Ticket \"{0}\" deleted successfully.",
    NOT_DELETED: "An error occurred while deleting the ticket \"{0}\".",
    ASSIGNED: "Assistance request taken in charge successfully.",
    NOT_ASSIGNED: "An error occurred while taking in charge the assistance request.",
    RELEASED: "Assistance request released successfully.",
    NOT_RELEASED: "An error occurred while releasing the assistance request.",
    COMPLETED: "Assistance request closed successfully.",
    NOT_COMPLETED: "An error occurred while closing the assistance request.",
    REASSIGNED: "Assistance request reassigned successfully.",
    NOT_REASSIGNED: "An error occurred while reassigning the assistance request.",
    SESSION_LINKED: "Session linked to the assistance request successfully.",
    SESSION_NOT_LINKED: "An error occurred while linking the session to the assistance request.",
    POLL_FAILED: "An error occurred while polling for new assistance requests.",
}

/*************************************CUSTOMERS**************************************************************************/
export const CUSTOMER_MESSAGES={
    CREATED: "Customer \"{0}\" created successfully.",
    NOT_CREATED: "An error occurred while creating the customer \"{0}\".",
    MODIFIED: "Customer \"{0}\" modified successfully.",
    NOT_MODIFIED: "An error occurred while editing the customer \"{0}\".",
    DELETED: "Customer \"{0}\" deleted successfully.",
    NOT_DELETED: "An error occurred while deleting the customer \"{0}\".",
    LIST_NOT_RETRIEVED: "An error occurred while retrieving the customers.",
    NOT_RETRIEVED: "An error occurred while retrieving the customer.",
    GROUPS_ASSIGNED: "Groups associated to the customer successfully.",
    GROUPS_NOT_ASSIGNED: "An error occurred while associating the groups to the customer.",
    SUMMARY_NOT_RETRIEVED: "An error occurred while retrieving the customer summary.",
}

/*************************************BILLING**************************************************************************/
export const BILLING_MESSAGES={
    CARNET_LIST_NOT_RETRIEVED: "An error occurred while retrieving the carnets.",
    CARNET_CREATED: "Carnet created successfully.",
    CARNET_NOT_CREATED: "An error occurred while creating the carnet.",
    EXPORT_FAILED: "An error occurred while exporting the billing data.",

    INVOICE_LIST_NOT_RETRIEVED: "An error occurred while retrieving the invoices.",
    INVOICE_NOT_RETRIEVED: "An error occurred while retrieving the invoice.",
    INVOICE_CREATED: "Invoice created successfully.",
    INVOICE_NOT_CREATED: "An error occurred while creating the invoice.",
    INVOICE_DELETED: "Invoice deleted successfully.",
    INVOICE_NOT_DELETED: "An error occurred while deleting the invoice.",
    INVOICE_MARKED: "Invoice marked as invoiced successfully.",
    INVOICE_NOT_MARKED: "An error occurred while marking the invoice as invoiced.",
    INVOICE_GENERATED: "Invoices generated successfully.",
    INVOICE_NOT_GENERATED: "An error occurred while generating the invoices.",
    NO_TICKETS_FOUND: "No tickets found for the selected customer and period.",
    CUSTOMER_NOT_FOUND: "Customer not found.",
}
